import getRequest from '@/client/utils/getRequest'
import { basePath } from '@/next.config'

export const clientGetMixes = async (trackId: number): Promise<Track[]> => {
	const mixes = await getRequest<Track[]>(
		`${basePath}/api/musicapp/music/tracks/mixes?trackId=${trackId}`,
		'mixes'
	)

	return mixes ?? []
}
